import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, TextField, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import DisplayDay from './DisplayDay';

export default function DisplayMenus(props) {

  const [open, setOpen] = React.useState(false);
  const [WarningClose, setWarningClose] = React.useState(false);
  const [WeekState, setWeekState] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setWarningClose(false)
    setOpen(false);
  };

  const handleReturn = () => {
    setWarningClose(false)
  };

  const handleWarningClose = () => {
    setWarningClose(true);
  };

  const checkChoices = (event) => {
    setWeekState(event.target.value)
  }

  return (
    <div style={{display: "flex", flexDirection: "row"}}>
      <div style={{display: "flex", flexDirection: "column"}}>
        <TextField required type="text" name="week" label="numéro de semaine" id="week" value={WeekState} onChange={checkChoices} style={{width: "15vw"}} />
        <Button disabled={WeekState === '' ? true : false} variant="outlined" onClick={handleClickOpen} endIcon={<AddBoxIcon />} style={{marginTop: "1vh", width: "15vw"}}>
            Ajouter les choix du client
        </Button>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'xl'}
          size="small"
          scroll={'paper'}
        >
          <DialogContent>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Lundi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'1'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Mardi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'2'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Mercredi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'3'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Jeudi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'4'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Vendredi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'5'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Samedi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'6'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Dimanche</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DisplayDay day={'7'} week={WeekState} uid={props.UserSession.uid} Customer={props.Customer}/>
              </AccordionDetails>
            </Accordion>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose} endIcon={<DoneAllIcon />}>Valider</Button>
            <Button variant="outlined" onClick={handleWarningClose} endIcon={<CloseIcon />}>Fermer</Button>
            <Dialog
              open={WarningClose}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              maxWidth={'lg'}
              size="small"
            >
              <DialogContent>
                Etes-vous certain de vouloir quitter ? Toute donnée non sauvegardé sera perdu.
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" color="success" onClick={handleReturn} >Annuler</Button>
                <Button variant="outlined" color="error" onClick={handleClose} endIcon={<CloseIcon />}>Confirmer</Button>
              </DialogActions>
            </Dialog>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  )
}